import React, { Component } from "react";
import { injectIntl } from 'react-intl';
import withStyles from "isomorphic-style-loader/withStyles";
import { SampleNextArrow, SamplePrevArrow } from "../../../helpers/swiper";
import s from 'swiper/swiper-bundle.css';
import t from '../../../styles/customSwiper.css';


class SliderCommonComponent extends Component {

    constructor(props) {
        super(props);
        if (typeof window !== 'undefined') {
            this.swiperPackage = require('swiper/react');
            this.swiperModule = require('swiper/modules')
        }
    }

    render() {
        const { spaceBetween, slidesPerGroup, slidesPerView, breakpoints, rtl } = this.props;
        const { Swiper } = this.swiperPackage;
        const { Navigation, Mousewheel } = this.swiperModule;
        const params = {
            modules: [Navigation, Mousewheel],
            navigation: {
                nextEl: `.searchHeaderNextBtn`,
                prevEl: `.searchHeaderPrevBtn`,
            },
            direction: 'horizontal',
            grabCursor: true,
            mousewheel: true
        };

        return (
            <div className={'searchPageSwiperContainer'}>
                <Swiper {...params} spaceBetween={spaceBetween} slidesPerGroup={slidesPerGroup} slidesPerView={slidesPerView} breakpoints={breakpoints} rtl={rtl} >
                    {this.props.children}
                </Swiper>
                <div>
                    <SamplePrevArrow isSearchPage={true} className={"searchHeaderPrevBtn"} />
                    <SampleNextArrow isSearchPage={true} className={"searchHeaderNextBtn"} />
                </div>
            </div>
        )
    }
}

export default injectIntl(withStyles(s, t)(SliderCommonComponent));